import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { UserTokenBaseEffect } from './user-token-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ UserTokenBaseEffect ])
  ]
})
export class UserTokenBaseModule {
}
